import { useMainClockContext } from "./context"

// Renderer component subscibing to MainClockContext
// Avoids having to subscribe to the main clock
// at a top level component
export const MainClockRenderer = ({
  render,
}: {
  render: (date: Date) => React.ReactNode,
}) => {
  const date = useMainClockContext();
  return <>{render(date)}</>;
};